import { z } from "zod";

// ─── Enums ───────────────────────────────────────────────────────────────────

export const CampaignStatusSchema = z.enum(["active", "draft", "suspended"]);
export type CampaignStatus = z.infer<typeof CampaignStatusSchema>;

export const CampaignGoalTypeSchema = z.enum([
  "date",
  "hires",
  "budget",
  "perpetual",
]);
export type CampaignGoalType = z.infer<typeof CampaignGoalTypeSchema>;

// ─── Core Entity ─────────────────────────────────────────────────────────────

export const CampaignSchema = z.object({
  campaignId: z.uuid(),
  name: z.string(),
  role: z.string(),
  location: z.string(),
  status: CampaignStatusSchema,
  companyId: z.uuid(),
  applicants: z.number().int().nonnegative(),
  pipelineCount: z.number().int().nonnegative(),
  hires: z.number().int().nonnegative(),
  spend: z.number().nonnegative(),
  budget: z.number().nonnegative().optional(),
  goalType: CampaignGoalTypeSchema,
  goalValue: z.string().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type Campaign = z.infer<typeof CampaignSchema>;

// ─── Response Schemas ─────────────────────────────────────────────────────────

export const CampaignListResponseSchema = z.object({
  campaigns: z.array(CampaignSchema),
  count: z.number(),
});
export type CampaignListResponse = z.infer<typeof CampaignListResponseSchema>;

// ─── Request Schemas ──────────────────────────────────────────────────────────

export const CreateCampaignRequestSchema = z.object({
  name: z.string().min(1),
  role: z.string().min(1),
  location: z.string().min(1),
  budget: z.number().nonnegative().optional(),
  goalType: CampaignGoalTypeSchema,
  goalValue: z.string().optional(),
});
export type CreateCampaignRequest = z.infer<typeof CreateCampaignRequestSchema>;

export const UpdateCampaignRequestSchema = CreateCampaignRequestSchema.partial().extend({
  status: CampaignStatusSchema.optional(),
  spend: z.number().nonnegative().optional(),
});
export type UpdateCampaignRequest = z.infer<typeof UpdateCampaignRequestSchema>;
